import { render, staticRenderFns } from "./ProductsTab.vue?vue&type=template&id=0bdce238&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ProductsTab.vue?vue&type=script&lang=js&"
export * from "./ProductsTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTab.vue?vue&type=style&index=0&id=0bdce238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdce238",
  null
  
)

export default component.exports